;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="b0b6165b-2de9-4bc4-a764-91c6ebf76b49",e._sentryDebugIdIdentifier="sentry-dbid-b0b6165b-2de9-4bc4-a764-91c6ebf76b49")}catch(e){}}();import events from 'events-bus';
import { useState, useEffect } from 'react';
import { GET_CART_EVENT, ADD_TO_CART_EVENT } from '../utils/constants.js';
import '../_virtual/_sentry-release-injection-file.js';

const DEFAULT_CART = {
    summary: { articleCount: 0 },
};
function useCart() {
    const [cart, setCart] = useState(DEFAULT_CART);
    useEffect(() => {
        const updateCart = (_eventName, data) => {
            setCart(data.response ?? DEFAULT_CART);
        };
        events.on(GET_CART_EVENT, updateCart);
        events.on(ADD_TO_CART_EVENT, updateCart);
        return () => {
            events.off(updateCart);
        };
    }, []);
    return [cart];
}

export { useCart };
//# sourceMappingURL=useCart.js.map
